import { IContactDetails } from '../../models';

interface IContactDetailsFormFields {
  contactDetails_firstName: string | null;
  contactDetails_surname: string | null;
  contactDetails_address: string | null;
  contactDetails_number: string | null;
  contactDetails_postalcode: string | null;
  contactDetails_city: string | null;
  contactDetails_country: string | null;
  contactDetails_telephone: string | null;
  contactDetails_email: string | null;
  contactDetails_websites: Array<string> | null;
}

export function handleContactDetailsFormDefaultValues(
  contact_details: IContactDetails
): IContactDetailsFormFields {
  return {
    contactDetails_firstName: contact_details.first_name,
    contactDetails_surname: contact_details.last_name,
    contactDetails_address: contact_details.street,
    contactDetails_number: contact_details.building_identifier,
    contactDetails_postalcode: contact_details.post_code,
    contactDetails_city: contact_details.city,
    contactDetails_country: contact_details.country_id
      ? `${contact_details.country_id}`
      : null,
    contactDetails_telephone: contact_details.telephone,
    contactDetails_email: contact_details.email,
    contactDetails_websites: websitesToArray(contact_details.website_url),
  };
}

const websitesToArray = (websites: any): Array<string> => {
  let array: Array<string> = [];
  if (websites) for (let item of websites) array.push(item.website_url);
  return array;
};
